import React, { Component, useState } from 'react';
import './logoSection.css';
import DesignSection from './designSection';
import SectionBanner from './sectionBanner';
import SectionPageHeader from './sectionPageHeader';
import { AddToClipBoard } from './../../utils/functions';

function CopyImageURLButton({ url }) {
  const [copied, setCopied] = useState(false);
  const [hovered, setHovered] = useState(false);

  const handleCopy = () => {
    AddToClipBoard('https://design.yipitdata.com' + url);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div
      onClick={handleCopy}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        cursor: 'pointer',
        padding: '4px 8px',
        borderRadius: '4px',
        backgroundColor: hovered || copied ? 'rgba(0, 110, 133, 0.07)' : 'transparent',
        color: copied ? '#006E85' : hovered ? '#006E85' : 'rgba(0,0,0,0.45)',
        transition: 'color 0.15s ease, background-color 0.15s ease',
        userSelect: 'none',
        marginTop: '6px',
      }}
    >
      <span
        className="material-symbols-rounded"
        style={{ fontSize: '16px', lineHeight: 1 }}
      >
        {copied ? 'check' : 'content_copy'}
      </span>
      <span style={{ fontSize: '0.8rem' }}>{copied ? 'Copied!' : 'Copy Image Address'}</span>
    </div>
  );
}

let data = [
  {
    title:'Coverage Summary',
    src:'/design/email-banner-coverage.png'
  },
  {
    title:'Medtech',
    src:'/design/email-banner-medtech.png'
  },
  {
    title:'General',
    src:'/design/email-banner-data.png'
  },
  {
    title:'Signals',
    src:'/design/email-banner-signals.png'
  },
  {
    title:'Signals (Option 2)',
    src:'/design/email-banner-signals-2.png'
  },
  {
    title:'Software',
    src:'/design/email-banner-software.png'
  },
  {
    title:'Investor',
    src:'/design/email-banner-investors.png'
  },
  {
    title:'Summit',
    src:'/design/email-banner-summit.png'
  },
  {
    title:'Spendhound Benchmarking',
    src:'/design/email-banner-spendhound-benchmarking.png'
  },
  {
    title:'Spendhound Referral',
    src:'/design/email-banner-spendhound-referral-aug-sep.png'
  },  
  {
    title:'Spendhound AI Report',
    src:'/design/email-banner-spendhound-ai-report.png'
  },
  {
    title:'Ask Yipit',
    src:'/design/email-banner-ask-yipit.png'
  },
  {
    title:'YipitData Logo',
    src:'/design/email-yipitdata-logo.png'
  },
  {
    title:'Spendhound Logo',
    src:'/design/email-spendhound-yipitdata-logo.png'
  }
]

export default class EmailSection extends Component {

  copyLink = (url) =>{
    AddToClipBoard('https://design.yipitdata.com'+url)
  }

  render() {
    return (
      <div className="sectionContainer full-width">
        <SectionBanner image="/images/background-lines-gradient-purple.webp" title="Email Signatures" />
        <SectionPageHeader description="Email signatures are one of the most frequently seen brand touchpoints across the company. Using an approved signature ensures every email we send reflects our identity consistently and professionally." />
        <DesignSection
          title={'Instructions'}>
          <div>
            <p className="tiny-bottom-margin">Follow the instructions to add an image to your email signature:</p>
            <p>1. Right click the image of your choosing and click "Copy Image Address"</p>
            <p>2. Open your Gmail settings by clicking the gear icon</p>
            <p>3. Scroll down to Email signature settings</p>
            <p>4. Place your cursor where you want to add the image</p>
            <p>5. Click the mountain icon to choose an image and select "Web Address (URL)" </p>
            <p>6. Paste the image URL</p>
            <p>7. Highlight the image and click the link icon (pro tip: the link shortcut is Command + K)</p>
            <p>8. Paste the website url "https://www.yipitdata.com" (or paste the url of your choosing)</p>
            <p>9. Click Save Changes at the bottom of the page</p>
          </div>
          <div style={{ maxWidth: '600px' }}>
            {data && data.map((item) =>{
              return(
                <div className="small-top-margin" >
                  <p className="tiny-bottom-margin"><b>{item.title}</b></p>
                  <img src={item.src} />
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <CopyImageURLButton url={item.src} />
                  </div>
                </div>
              )
            })}
          </div>
        </DesignSection>
      </div>
    );
  }
}
